const timeMatchers = {
  hour: new RegExp(/([0-9]|1[0-2]):/),
  minute: new RegExp(/:([0-9]{2})/),
  period: new RegExp(/[A-Z]{2}/)
};

function createRange(start: number, end: number): number[] {
  const range = [];
  for (let i = start; i <= end; i++) {
    range.push(i);
  }

  return range;
}

function splitTime(time: string): { hour: number; minute: string; period: string } {
  const hour = parseInt(time.match(timeMatchers.hour)[1], 10);
  const minute = time.match(timeMatchers.minute)[1];
  const period = time.match(timeMatchers.period)[0];
  return { hour, minute, period };
}
export { createRange, splitTime };
